/** Resumo legível de um user-agent: "Chrome · macOS". Sem biblioteca: só o que o painel precisa. */
export function describeUserAgent(ua: string | null | undefined): string {
  if (!ua) return 'Dispositivo desconhecido';
  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /OPR\//.test(ua)
      ? 'Opera'
      : /Chrome\//.test(ua)
        ? 'Chrome'
        : /Firefox\//.test(ua)
          ? 'Firefox'
          : /Safari\//.test(ua) && /Version\//.test(ua)
            ? 'Safari'
            : /curl|node|axios|python|lightMyRequest/i.test(ua)
              ? 'Cliente de API'
              : 'Navegador';
  const os = /iPhone|iPad/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /Windows/.test(ua)
        ? 'Windows'
        : /Mac OS X|Macintosh/.test(ua)
          ? 'macOS'
          : /CrOS/.test(ua)
            ? 'ChromeOS'
            : /Linux/.test(ua)
              ? 'Linux'
              : null;
  return os ? `${browser} · ${os}` : browser;
}
